import { render, staticRenderFns } from "./VPlyr.vue?vue&type=template&id=3392fd24&"
import script from "./VPlyr.vue?vue&type=script&lang=ts&"
export * from "./VPlyr.vue?vue&type=script&lang=ts&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports